import LegalImg from "../../../images/LEGAL.png";
import React from "react";
import { Box, Container, Typography, Button, Grid } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

const Legal = () => {
  const navigate = useNavigate();

  // Hero Section with Background Image
  const HeroSection = () => (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "50vh", md: "70vh" },
        backgroundImage: `url(${LegalImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
        }}
      />

      {/* Content */}
      <Container
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: "#fff",
            letterSpacing: 2,
            opacity: 0.9,
          }}
        >
          Specialization
        </Typography>

        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mt: 1,
            mb: 2,
          }}
        >
          Legal & Compliance
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.85)",
            maxWidth: 600,
            mb: 3,
          }}
        >
          Delivering experienced legal and compliance professionals dedicated to
          protecting your organization, ensuring regulatory adherence, and
          providing strategic legal guidance.
        </Typography>

        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: "#1976d2",
            px: 4,
            py: 1.2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "15px",
            "&:hover": {
              backgroundColor: "#115293",
            },
          }}
          onClick={() => navigate("/contact-us")}
        >
          Get in Touch
        </Button>
      </Container>
    </Box>
  );

  return (
    <Box>
      <HeroSection />

      {/* Legal Jobs Section */}
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              mb: { xs: 6, md: 8 },
              color: "#0a3b4a",
              fontSize: { xs: "2rem", md: "2.4rem" },

            }}
          >
            Legal Jobs
          </Typography>

          {/* Row 1 */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Chief Legal Officer */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Chief Legal Officer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Heads the corporate legal department and is responsible for
                  the organization&apos;s legal affairs. Provides legal counsel to
                  senior leadership and the board, oversees legal strategy,
                  manages legal risk and ensures compliance with laws and
                  regulations across all jurisdictions.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Patent Attorney */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Patent Attorney
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Specializes in copyright and trademark law and protects
                  intellectual property. Drafts and prosecutes patent
                  applications, advises on IP strategy, evaluates patentability
                  and supports licensing and enforcement actions.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Paralegal or Legal Assistant */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Paralegal or Legal Assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Supports lawyers by preparing transactional documents,
                  assisting with closings, hearings and trials, conducting legal
                  research, organizing discovery, drafting pleadings and
                  maintaining case-management databases.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Office Clerk */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Office Clerk
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Entry-level administrative role supporting daily operations of
                  a legal office. Duties include filing and scanning documents,
                  operating standard office equipment, processing incoming and
                  outgoing mail and supporting other staff as needed.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 2 */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Legal Secretary */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Legal Secretary
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Provides specialized administrative support in a law office.
                  Prepares and proofreads legal documents, manages calendars and
                  deadlines, maintains client files, arranges meetings and
                  assists attorneys with court filings and correspondence.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Lawyer */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Lawyer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Represents clients in complex legal matters, drafts and
                  negotiates contracts, prepares briefs and pleadings, appears
                  in court or before regulators and provides legal advice on
                  risk, rights and obligations.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* First-Year Associate */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  First-Year Associate
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Entry-level attorney who supports senior lawyers with legal
                  research, drafting motions and transactional documents,
                  reviewing contracts and assisting with discovery and client
                  communication while learning firm standards and practices.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* File Clerk */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  File Clerk
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Maintains paper and electronic filing systems for legal
                  documents. Retrieves files, tracks file movement, scans and
                  indexes records and ensures sensitive information is handled
                  securely and confidentially.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 3 */}
          <Grid container spacing={{ xs: 6, md: 8 }}>
            {/* Executive Assistant */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Executive Assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Provides high-level administrative support to senior legal
                  executives, including managing calendars, arranging meetings
                  and travel, preparing reports and presentations and
                  coordinating communication with internal and external
                  stakeholders.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Corporate Counsel */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Corporate Counsel
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  In-house attorney providing legal advice on corporate matters.
                  Drafts and negotiates company contracts, advises on corporate
                  governance, manages regulatory compliance and supports senior
                  management on strategic initiatives and risk mitigation.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Contract Administrator */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Contract Administrator
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Manages contracts with customers, vendors and partners.
                  Reviews terms for accuracy and risk, tracks key dates, ensures
                  compliance with obligations and collaborates with legal and
                  business teams to resolve contract issues.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Paralegal or Legal Assistant (repeat for bottom row) */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#102a6b", fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, }}
                >
                  Legal
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: "#102a6b", fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, }}
                >
                  Paralegal or Legal Assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563", lineHeight: 1.7, fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Provides ongoing support to attorneys by organizing case files,
                  managing discovery, preparing closing binders, tracking
                  deadlines and coordinating documentation for litigation and
                  transactional matters.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Legal;
